import { PortalRefusal } from "@/data/api/client";
import { parseStoredCustomFields } from "@/domain/custom-fields/schema";
import type { OfferCancellation, PartnerOffer } from "@/domain/offer/types";

export interface PartnerOfferPayload {
  id: number;
  activityId: number;
  activityName: string | null;
  slotId: number;
  startTime: string;
  endTime: string;
  capacity: number | null;
  reserved: number | null;
  priceOriginal: number | null;
  priceDiscounted: number | null;
  windowStart: string | null;
  windowEnd: string | null;
  customFields?: unknown;
}

export interface OfferCancellationPayload {
  offerId: number;
  reservationCount: number | null;
  refundAmount: number | null;
  keptShareCount?: number | null;
  refundFailedAmount?: number | null;
  hasReservationHistory?: boolean | null;
}

function toDate(value: string | null): Date | null {
  if (value == null) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** A sleva is its hour: the list stages it, groups it by day and prefills the
 *  edit form from it. Standing in an instant for one the API did not send would
 *  show a termín that ended in 1970, so an unreadable one stops here instead. */
function requireInstant(value: string): Date {
  const parsed = toDate(value);
  if (parsed === null) {
    throw new PortalRefusal(
      "Termíny se nepodařilo zobrazit — u jednoho z nich nejde přečíst čas konání. Ozvěte se nám prosím.",
    );
  }
  return parsed;
}

export function payloadToPartnerOffer(payload: PartnerOfferPayload): PartnerOffer {
  return {
    id: payload.id,
    activityId: payload.activityId,
    activityName: payload.activityName ?? "Neznámá šablona slev",
    slotId: payload.slotId,
    startTime: requireInstant(payload.startTime),
    endTime: requireInstant(payload.endTime),
    capacity: payload.capacity ?? 0,
    reserved: payload.reserved ?? 0,
    priceOriginal: payload.priceOriginal,
    priceDiscounted: payload.priceDiscounted,
    saleWindow: {
      startsAt: toDate(payload.windowStart),
      endsAt: toDate(payload.windowEnd),
    },
    customFields: parseStoredCustomFields(payload.customFields),
  };
}

export function payloadToOfferCancellation(
  payload: OfferCancellationPayload,
): OfferCancellation {
  return {
    offerId: payload.offerId,
    reservationCount: payload.reservationCount ?? 0,
    refundAmountMinor: payload.refundAmount ?? 0,
    keptShareCount: payload.keptShareCount ?? 0,
    refundFailedAmountMinor: payload.refundFailedAmount ?? 0,
    hasReservationHistory: payload.hasReservationHistory ?? false,
  };
}
